define('presentation/settings/liveReceptionistScripts/viewModels/liveReceptionistScriptIntegrationsTabViewModel',[
    'common/collections/collectionSorter',
    'common/promises/promiseFactory',
    'settings/navigationConfiguration'
], function () {
    return function () {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const CollectionSorterConstructor = require('common/collections/collectionSorter');
        const _sorter = new CollectionSorterConstructor();

        const _i18n = require('i18next');
        const _navigationConfiguration = require('settings/navigationConfiguration');

        const _filterAvailableSelections = (availableIntegrations, selectedIntegrations, propertyPath) => {
            _sorter.sort(availableIntegrations, propertyPath, true);
            return availableIntegrations.filter((integration) => {
                return undefined === selectedIntegrations.find((selectedIntegration) => {
                    return integration.id === selectedIntegration().id;
                });
            });
        };

        self.connectIntegrationsUrl = _navigationConfiguration.routesById.integrations.url;
        self.connectIntegrationsLinkText = _i18n.t('addLiveReceptionistScript:connectIntegrations');
        self.noIntegrationsWarningMessage = _i18n.t('addLiveReceptionistScript:noIntegrationsFound');
        self.isCompositionComplete = ko.observable(false);
        self.availableIntegrations = ko.observableArray([]);
        self.selectedIntegrations = ko.observableArray([]);
        self.filterAvailableIntegrations = (availableIntegrations, selectedIntegrations) => {
            return _filterAvailableSelections(availableIntegrations, selectedIntegrations, 'name');
        };

        self.addItemTitle = ko.pureComputed(() => {
            return self.selectedIntegrations().length === 0 ? _i18n.t('addLiveReceptionistScript:addIntegration') : _i18n.t('addLiveReceptionistScript:addAnother');
        });

        self.showNoIntegrationsMessage = ko.pureComputed(() => {
            return (self.availableIntegrations().length === 0);
        });

        self.detached = () => {
            self.isCompositionComplete(false);
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.activate = (availableIntegrations, selectedIntegrations) => {
            self.availableIntegrations = availableIntegrations;
            self.selectedIntegrations = selectedIntegrations;
            return _initialize();
        };

        const _initialize = () => {
            return _promiseFactory.defer((initPromise) => {
                initPromise.resolve();
            });
        };
    };
});

